export const type = 'getSavedOrders';

const getSavedOrders = (companyIdentifier) => ({
    type,
    payload: companyIdentifier,
});

export default getSavedOrders;